module.exports = __webpack_public_path__ + "static/img/icons.6ffe01bf.png";